import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'astroturf/react'

import { dismissValidationError } from 'actions/errors'
import { inviteeFirstNameErrorsSelector, inviteeLastNameErrorsSelector } from 'selectors'
import BookingField from 'components/enter_details/booking_field'
import BookingTextField from 'components/form/text'
import { useI18n } from 'locales'
import _TextField from "seperated_name_input-TextField.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/booking_form/scheduling_form_feature/invitee_inputs/seperated_name_input.js?styleId=TextField";
import _Row from "seperated_name_input-Row.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/booking_form/scheduling_form_feature/invitee_inputs/seperated_name_input.js?styleId=Row";
import _Column from "seperated_name_input-Column.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/booking_form/scheduling_form_feature/invitee_inputs/seperated_name_input.js?styleId=Column";


const TextField = /*#__PURE__*/styled(BookingTextField, null, {
  displayName: "TextField",
  styles: _TextField
})

const FirstName = ({ firstName, onChange }) => {
  const { i18n } = useI18n()
  const firstNameErrors = useSelector(inviteeFirstNameErrorsSelector)
  const dispatch = useDispatch()
  const dismissError = () => dispatch(dismissValidationError('invitee', 'first_name'))

  const handleChange = (...args) => {
    dismissError()
    onChange(...args)
  }
  if (!(firstName)) return null

  return (
    <BookingField>
      <TextField
        label={i18n.t('booking.templates.first_name')}
        name="first_name"
        value={firstName.value}
        maxLength={155}
        required={firstName.required}
        onChange={handleChange}
        error={firstNameErrors?.[0]}
        autoComplete="given-name"
      />
    </BookingField>
  )
}

const LastName = ({ lastName, onChange }) => {
  const { i18n } = useI18n()
  const lastNameErrors = useSelector(inviteeLastNameErrorsSelector)
  const dispatch = useDispatch()
  const dismissError = () => dispatch(dismissValidationError('invitee', 'last_name'))

  const handleChange = (...args) => {
    dismissError()
    onChange(...args)
  }

  if (!(lastName)) return null
  return (
    <BookingField>
      <TextField
        label={i18n.t('booking.templates.last_name')}
        name="last_name"
        value={lastName.value}
        maxLength={155}
        required={lastName.required}
        onChange={handleChange}
        error={lastNameErrors?.[0]}
        autoComplete="family-name"
      />
    </BookingField>
  )
}

const Row = /*#__PURE__*/styled('div', null, {
  displayName: "Row",
  styles: _Row
})

const Column = /*#__PURE__*/styled('div', null, {
  displayName: "Column",
  styles: _Column
})

const SeparatedNameInput = ({ firstName, lastName, onChange }) => (
  <Row>
    <Column data-component="invitee-input-first-name">
      <FirstName firstName={firstName} onChange={onChange} />
    </Column>
    <Column data-component="invitee-input-last-name">
      <LastName lastName={lastName} onChange={onChange} />
    </Column>
  </Row>
)

SeparatedNameInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  firstName: PropTypes.shape({
    value: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired
  }),
  lastName: PropTypes.shape({
    value: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired
  })
}

export default SeparatedNameInput
